export enum StageStatus {
  NOT_RELEASED = "Not Released",
  NOW_SELLING = "Now Selling",
  SOLD_OUT = "Sold Out",
}
